import './footercontent.css';

export default function Footercontent() {
	return (
		<>
			<footer className="footer-container">
				<p>Note: The following links will open in a new browser window.</p>
				<nav>
					<ul className="footer-link-list">
						<li><a href="https://www.prudential.com/links/privacy-center"
							aria-label="Privacy Center Opens in New Window" target="_blank">Privacy Center</a>
						</li>
						<li><a href="https://www.prudential.com/links/business-integrity"
							aria-label="Business Integrity Opens in New Window" target="_blank">Business Integrity
						</a></li>
						<li><a href="https://www.prudential.com/media/managed/terms.html" aria-label="Terms and
								Conditions Opens in New Window" target="_blank">Terms and
							Conditions
						</a></li>
						<li><a href="https://www.prudential.com/links/about/accessibility-form"
							aria-label="Accessibility Help Opens in New Window" target="_blank">Accessibility
							Help</a></li>
					</ul>
				</nav>
				<div className="row">
					<p>Life insurance is issued by The Prudential Insurance Company
						of America, Pruco Life Insurance Company (except in NY and/or NJ),
						and Pruco Life Insurance Company of New Jersey (in NY and/or NJ).
						All are Prudential Financial companies located in Newark, NJ.
						Securities products and services are offered through Pruco
						Securities, LLC located in Newark, NJ.</p>
					<p>"Prudential Advisors" is a brand name of The Prudential Insurance Company of America and
						its subsidiaries.</p>
					<p>Prudential, the Prudential logo, and the Rock symbol are
						service marks of Prudential Financial, Inc. and its related
						entities.</p>
					<p> This material is being provided for informational or educational purposes only and does
						not take into account the investment objectives or financial situation of any of your
						clients or prospective clients. The information is not intended as investment advice and
						is not a recommendation about managing or investing your client's retirement savings.
						Clients seeking information regarding their particular investment needs should contact a
						financial professional.</p>
					<p>For Financial Professional Use Only. Not for Use with the
						General Public. For consumer information, please visit
						<a target="_blank" href="https://www.prudential.com/">www.prudential.com</a>
					</p>
					<p>1021194-00006-00 Ed. 07/2023 </p>
					<p>&#169; 2023 Prudential Financial, Inc. and its related entities.</p>
				</div>
			</footer>
		</>
	)
}